// extracted by mini-css-extract-plugin
export default {"question":"profile-form-link_question__54Zf0","link":"profile-form-link_link__ZNBvy"};